import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { useStore } from 'vuex'
import HelpView from '../views/HelpView.vue'
import TermsView from '../views/TermsView.vue'
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '首页 - 及时复习', requiresAuth: true  }
  },
  {
    path: '/notes',
    name: 'notes',
    component: () => import('../views/NotesView.vue'),
    meta: { title: '笔记管理 - 及时复习', requiresAuth: true }
  },
  {
    path: '/notes/new',
    name: 'new-note',
    component: () => import('../views/EditNoteView.vue'),
    meta: { title: '添加笔记 - 及时复习', requiresAuth: true }
  },
  {
    path: '/notes/:id',
    name: 'edit-note',
    component: () => import('../views/EditNoteView.vue'),
    meta: { title: '编辑笔记 - 及时复习', requiresAuth: true }
  },
  {
    path: '/review-today',
    name: 'review-today',
    component: () => import('../views/ReviewTodayView.vue'),
    meta: { title: '今日复习', requiresAuth: true }
  },
  {
    path: '/review-plan',
    name: 'review-plan',
    component: () => import('../views/ReviewPlanView.vue'),
    meta: { title: '复习计划 - 及时复习', requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/ProfileView.vue'),
    meta: { title: '个人中心 - 及时复习', requiresAuth: true }
  },
  {
    path: '/word-book',
    name: 'WordBook',
    component: () => import('@/views/WordBookView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { title: '用户登录', requiresAuth: false }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/RegisterView.vue'),
    meta: { title: '用户注册', requiresAuth: false }
  },
  {
    path: '/registerByPhone',
    name: 'registerByPhone',
    component: () => import('../views/RegisterByPhone.vue'),
    meta: { title: '用户注册', requiresAuth: false }
  },
  {
    path: '/help',
    name: 'help',
    component: HelpView
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/ContactView.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyPolicyView,
    meta: {
      title: '隐私政策',
      requiresAuth: false // 不需要登录就可以访问
    }
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsView
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPasswordView.vue')
  },
  {
    path: '/anki-library',
    name: 'anki-library',
    component: () => import('../views/AnkiLibraryView.vue'),
    meta: { title: 'Anki资源库 - 及时复习', requiresAuth: true }
  },
  {
    path: '/anki-learn',
    name: 'anki-learn',
    component: () => import('../views/AnkiLearnView.vue'),
    meta: { title: 'Anki学习 - 及时复习', requiresAuth: true }
  },
  {
    path: '/anki-review',
    name: 'anki-review',
    component: () => import('../views/AnkiReviewView.vue'),
    meta: { title: 'Anki复习 - 及时复习', requiresAuth: true }
  },
  {
    path: '/anki-upload',
    name: 'anki-upload',
    component: () => import('../views/AnkiUploadView.vue'),
    meta: { title: '上传Anki卡组 - 及时复习', requiresAuth: true }
  },
  {    path: '/anki-note-list',    name: 'anki-note-list',    component: () => import('../views/AnkiNoteListView.vue'),    meta: { title: '笔记列表 - 及时复习', requiresAuth: true }  },
  {    path: '/anki-note-edit',    name: 'anki-note-edit',    component: () => import('../views/AnkiNoteEditView.vue'),    meta: { title: '编辑笔记 - 及时复习', requiresAuth: true }  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 动态设置页面标题
router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || '喵记复习 - 高效学习助手'
  const store = useStore()
  const isAuthenticated = store.getters['user/isAuthenticated']
  
  // 如果是登录/注册页面，直接放行，不检查认证状态
  if (['login', 'register'].includes(to.name)) {
    store.commit('user/SET_NAV_VISIBLE', false)
    next()
    return
  }
  
  // 如果是其他不需要认证的页面，直接放行
  if (['help', 'privacy', 'terms'].includes(to.name)) {
    store.commit('user/SET_NAV_VISIBLE', true)
    next()
    return
  }
  
  // 如果未登录且访问需要认证的页面，跳转到登录页
  if (to.meta.requiresAuth && !isAuthenticated) {
    console.log('需要认证且未登录')
    store.commit('user/SET_NAV_VISIBLE', false)
    next({ name: 'login', query: { redirect: to.fullPath } })
    return
  }
  
  // 其他情况显示导航
  store.commit('user/SET_NAV_VISIBLE', true)
  next()
})

export default router